

const Masonry = require('masonry-layout');
const imagesLoaded = require('imagesloaded');

const element = '.js-masonry-grid';

if (document.querySelector(element)) {
    const grid = imagesLoaded(element, () => {
        new Masonry(grid.elements[0], {
            itemSelector: '.grid__item',
            percentPosition: true,
        });
    });
}
